import { render, staticRenderFns } from "./category-menu.vue?vue&type=template&id=7f31f6f3&scoped=true"
import script from "./category-menu.vue?vue&type=script&lang=js"
export * from "./category-menu.vue?vue&type=script&lang=js"
import style0 from "./category-menu.vue?vue&type=style&index=0&id=7f31f6f3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f31f6f3",
  null
  
)

export default component.exports